import React, { useState } from 'react';
import { FaRegLightbulb, FaBook, FaCheckCircle, FaHourglassHalf, FaFileAlt } from 'react-icons/fa';
import './PatentsBooks.css';
import { professorData } from '../data';

export default function PatentsBooks() {
  const { patents, books } = professorData;
  const [activeTab, setActiveTab] = useState('patents');

  return (
    <section id="patents" className="patents-books section section--alt">
      <div className="container">
        <div className="section-header">
          <span className="section-label">Intellectual Contributions</span>
          <h2 className="section-title">Patents & Books</h2>
          <div className="section-rule"></div>
        </div>

        <div className="pb-modern__tabs-wrapper">
          <div className="pb-modern__tabs">
            <button
              className={`pb-modern__tab ${activeTab === 'patents' ? 'active' : ''}`}
              onClick={() => setActiveTab('patents')}
            >
              <FaRegLightbulb className="pb-modern__tab-icon" />
              <span>Patents ({patents.length})</span>
            </button>
            <button
              className={`pb-modern__tab ${activeTab === 'books' ? 'active' : ''}`}
              onClick={() => setActiveTab('books')}
            >
              <FaBook className="pb-modern__tab-icon" />
              <span>Books ({books.length})</span>
            </button>
          </div>
        </div>

        <div className="pb-modern__content">
          {activeTab === 'patents' && (
            <div className="pb-modern__patents fade-in">
              {patents.map((p, i) => {
                const isPublished = p.status.includes('Published');
                return (
                  <div key={i} className="modern-patent-card">
                    <div className="modern-patent-card__icon">
                      <FaFileAlt />
                    </div>
                    <div className="modern-patent-card__body">
                      <div className="modern-patent-card__header">
                        <span className="modern-patent-card__no">Patent #{p.no.toString().padStart(2, '0')}</span>
                        <span className={`modern-patent-card__badge ${isPublished ? 'published' : 'filed'}`}>
                          {isPublished ? <FaCheckCircle /> : <FaHourglassHalf />}
                          {isPublished ? 'Published' : 'Filed'}
                        </span>
                      </div>
                      <h4 className="modern-patent-card__title">{p.title}</h4>
                      <div className="modern-patent-card__footer">
                        <span className="modern-patent-card__app">
                          <strong>App No:</strong> {p.appNo}
                        </span>
                        <span className="modern-patent-card__status">
                          <strong>Status:</strong> {p.status}
                        </span>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}

          {activeTab === 'books' && (
            <div className="pb-modern__books fade-in">
              {books.map((b, i) => (
                <div key={i} className="modern-book-card">
                  <div className="modern-book-card__spine">
                    <span className="modern-book-card__num">{(i + 1).toString().padStart(2, '0')}</span>
                    <div className="modern-book-card__spine-lines"></div>
                  </div>
                  <div className="modern-book-card__body">
                    <h4 className="modern-book-card__title">{b.title}</h4>
                    <p className="modern-book-card__authors">
                      <strong>Authors:</strong> {b.authors}
                    </p>
                    <div className="modern-book-card__footer">
                      <span className="modern-book-card__publisher">
                        <FaBook className="inline-icon" /> {b.publisher}
                      </span>
                      <span className="modern-book-card__year">{b.year}</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
